module.exports = __webpack_public_path__ + "img/australia-pneumonia-male.4f80bc8d.png";